import { shadowTypes } from "../styles/UnitShadow";
import BaseURL from "./images/Hosting-BaseURL";

const orc1AImage = `${BaseURL}/Martial/Orcs/Orc 1 A.png`;
const orc1BImage = `${BaseURL}/Martial/Orcs/Orc 1 B.png`;
const orc1CImage = `${BaseURL}/Martial/Orcs/Orc 1 C.png`;
const orc1DImage = `${BaseURL}/Martial/Orcs/Orc 1 D.png`;
const orc1EImage = `${BaseURL}/Martial/Orcs/Orc 1 E.png`;
const orc1FImage = `${BaseURL}/Martial/Orcs/Orc 1 F.png`;
const orc1GImage = `${BaseURL}/Martial/Orcs/Orc 1 G.png`;
const orc1HImage = `${BaseURL}/Special/Christmas/Orc 1 H.png`;
const orc1BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 1 B.png`;
const orc1CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 1 C.png`;
const orc1DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 1 D.png`;
const orc1EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 1 E.png`;
const orc1FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 1 F.png`;
const orc1GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 1 G.png`;
const orc1HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 1 H.png`;

const orc2AImage = `${BaseURL}/Martial/Orcs/Orc 2 A.png`;
const orc2BImage = `${BaseURL}/Martial/Orcs/Orc 2 B.png`;
const orc2CImage = `${BaseURL}/Martial/Orcs/Orc 2 C.png`;
const orc2DImage = `${BaseURL}/Martial/Orcs/Orc 2 D.png`;
const orc2EImage = `${BaseURL}/Martial/Orcs/Orc 2 E.png`;
const orc2FImage = `${BaseURL}/Martial/Orcs/Orc 2 F.png`;
const orc2GImage = `${BaseURL}/Martial/Orcs/Orc 2 G.png`;
const orc2HImage = `${BaseURL}/Martial/Orcs/Orc 2 H.png`;
const orc2IImage = `${BaseURL}/Special/Christmas/Orc 2 I.png`;
const orc2BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 2 B.png`;
const orc2CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 2 C.png`;
const orc2DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 2 D.png`;
const orc2EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 2 E.png`;
const orc2FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 2 F.png`;
const orc2GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 2 G.png`;
const orc2HPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 2 H.png`;
const orc2IPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 2 I.png`;

const orc3AImage = `${BaseURL}/Martial/Orcs/Orc 3 A.png`;
const orc3BImage = `${BaseURL}/Martial/Orcs/Orc 3 B.png`;
const orc3CImage = `${BaseURL}/Martial/Orcs/Orc 3 C.png`;
const orc3DImage = `${BaseURL}/Martial/Orcs/Orc 3 D.png`;
const orc3EImage = `${BaseURL}/Martial/Orcs/Orc 3 E.png`;
const orc3FImage = `${BaseURL}/Martial/Orcs/Orc 3 F.png`;
const orc3GImage = `${BaseURL}/Martial/Orcs/Orc 3 G.png`;
const orc3HImage = `${BaseURL}/Special/Christmas/Orc 3 H.png`;
const orc3BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 3 B.png`;
const orc3CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 3 C.png`;
const orc3DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 3 D.png`;
const orc3EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 3 E.png`;
const orc3FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 3 F.png`;
const orc3GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 3 G.png`;
const orc3HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 3 H.png`;

const orc4AImage = `${BaseURL}/Martial/Orcs/Orc 4 A.png`;
const orc4BImage = `${BaseURL}/Martial/Orcs/Orc 4 B.png`;
const orc4CImage = `${BaseURL}/Martial/Orcs/Orc 4 C.png`;
const orc4DImage = `${BaseURL}/Martial/Orcs/Orc 4 D.png`;
const orc4EImage = `${BaseURL}/Martial/Orcs/Orc 4 E.png`;
const orc4FImage = `${BaseURL}/Martial/Orcs/Orc 4 F.png`;
const orc4GImage = `${BaseURL}/Martial/Orcs/Orc 4 G.png`;
const orc4HImage = `${BaseURL}/Special/Christmas/Orc 4 H.png`;
const orc4BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 4 B.png`;
const orc4CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 4 C.png`;
const orc4DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 4 D.png`;
const orc4EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 4 E.png`;
const orc4FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 4 F.png`;
const orc4GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 4 G.png`;
const orc4HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 4 H.png`;

const orc5AImage = `${BaseURL}/Martial/Orcs/Orc 5 A.png`;
const orc5BImage = `${BaseURL}/Martial/Orcs/Orc 5 B.png`;
const orc5CImage = `${BaseURL}/Martial/Orcs/Orc 5 C.png`;
const orc5DImage = `${BaseURL}/Martial/Orcs/Orc 5 D.png`;
const orc5EImage = `${BaseURL}/Martial/Orcs/Orc 5 E.png`;
const orc5FImage = `${BaseURL}/Martial/Orcs/Orc 5 F.png`;
const orc5GImage = `${BaseURL}/Martial/Orcs/Orc 5 G.png`;
const orc5HImage = `${BaseURL}/Special/Christmas/Orc 5 H.png`;
const orc5BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 5 B.png`;
const orc5CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 5 C.png`;
const orc5DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 5 D.png`;
const orc5EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 5 E.png`;
const orc5FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 5 F.png`;
const orc5GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 5 G.png`;
const orc5HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 5 H.png`;

const orc6AImage = `${BaseURL}/Martial/Orcs/Orc 6 A.png`;
const orc6BImage = `${BaseURL}/Martial/Orcs/Orc 6 B.png`;
const orc6CImage = `${BaseURL}/Martial/Orcs/Orc 6 C.png`;
const orc6DImage = `${BaseURL}/Martial/Orcs/Orc 6 D.png`;
const orc6EImage = `${BaseURL}/Martial/Orcs/Orc 6 E.png`;
const orc6FImage = `${BaseURL}/Martial/Orcs/Orc 6 F.png`;
const orc6GImage = `${BaseURL}/Martial/Orcs/Orc 6 G.png`;
const orc6HImage = `${BaseURL}/Special/Christmas/Orc 6 H.png`;
const orc6BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 6 B.png`;
const orc6CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 6 C.png`;
const orc6DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 6 D.png`;
const orc6EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 6 E.png`;
const orc6FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 6 F.png`;
const orc6GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 6 G.png`;
const orc6HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 6 H.png`;

const orc7AImage = `${BaseURL}/Martial/Orcs/Orc 7 A.png`;
const orc7BImage = `${BaseURL}/Martial/Orcs/Orc 7 B.png`;
const orc7CImage = `${BaseURL}/Martial/Orcs/Orc 7 C.png`;
const orc7DImage = `${BaseURL}/Martial/Orcs/Orc 7 D.png`;
const orc7EImage = `${BaseURL}/Martial/Orcs/Orc 7 E.png`;
const orc7FImage = `${BaseURL}/Martial/Orcs/Orc 7 F.png`;
const orc7GImage = `${BaseURL}/Martial/Orcs/Orc 7 G.png`;
const orc7HImage = `${BaseURL}/Special/Christmas/Orc 7 H.png`;
const orc7BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 7 B.png`;
const orc7CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 7 C.png`;
const orc7DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 7 D.png`;
const orc7EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 7 E.png`;
const orc7FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 7 F.png`;
const orc7GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 7 G.png`;
const orc7HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 7 H.png`;

const orc8AImage = `${BaseURL}/Martial/Orcs/Orc 8 A.png`;
const orc8BImage = `${BaseURL}/Martial/Orcs/Orc 8 B.png`;
const orc8CImage = `${BaseURL}/Martial/Orcs/Orc 8 C.png`;
const orc8DImage = `${BaseURL}/Martial/Orcs/Orc 8 D.png`;
const orc8EImage = `${BaseURL}/Martial/Orcs/Orc 8 E.png`;
const orc8FImage = `${BaseURL}/Martial/Orcs/Orc 8 F.png`;
const orc8GImage = `${BaseURL}/Martial/Orcs/Orc 8 G.png`;
const orc8HImage = `${BaseURL}/Special/Christmas/Orc 8 H.png`;
const orc8BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 8 B.png`;
const orc8CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 8 C.png`;
const orc8DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 8 D.png`;
const orc8EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 8 E.png`;
const orc8FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 8 F.png`;
const orc8GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 8 G.png`;
const orc8HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 8 H.png`;

const orc9AImage = `${BaseURL}/Martial/Orcs/Orc 9 A.png`;
const orc9BImage = `${BaseURL}/Martial/Orcs/Orc 9 B.png`;
const orc9CImage = `${BaseURL}/Martial/Orcs/Orc 9 C.png`;
const orc9DImage = `${BaseURL}/Martial/Orcs/Orc 9 D.png`;
const orc9EImage = `${BaseURL}/Martial/Orcs/Orc 9 E.png`;
const orc9FImage = `${BaseURL}/Martial/Orcs/Orc 9 F.png`;
const orc9GImage = `${BaseURL}/Martial/Orcs/Orc 9 G.png`;
const orc9HImage = `${BaseURL}/Special/Christmas/Orc 9 H.png`;
const orc9BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 9 B.png`;
const orc9CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 9 C.png`;
const orc9DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 9 D.png`;
const orc9EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 9 E.png`;
const orc9FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 9 F.png`;
const orc9GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 9 G.png`;
const orc9HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 9 H.png`;

const orc10AImage = `${BaseURL}/Martial/Orcs/Orc 10 A.png`;
const orc10BImage = `${BaseURL}/Martial/Orcs/Orc 10 B.png`;
const orc10CImage = `${BaseURL}/Martial/Orcs/Orc 10 C.png`;
const orc10DImage = `${BaseURL}/Martial/Orcs/Orc 10 D.png`;
const orc10EImage = `${BaseURL}/Martial/Orcs/Orc 10 E.png`;
const orc10FImage = `${BaseURL}/Martial/Orcs/Orc 10 F.png`;
const orc10GImage = `${BaseURL}/Martial/Orcs/Orc 10 G.png`;
const orc10HImage = `${BaseURL}/Special/Christmas/Orc 10 H.png`;
const orc10BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 10 B.png`;
const orc10CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 10 C.png`;
const orc10DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 10 D.png`;
const orc10EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 10 E.png`;
const orc10FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 10 F.png`;
const orc10GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 10 G.png`;
const orc10HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 10 H.png`;

const orc11AImage = `${BaseURL}/Martial/Orcs/Orc 11 A.png`;
const orc11BImage = `${BaseURL}/Martial/Orcs/Orc 11 B.png`;
const orc11CImage = `${BaseURL}/Martial/Orcs/Orc 11 C.png`;
const orc11DImage = `${BaseURL}/Martial/Orcs/Orc 11 D.png`;
const orc11EImage = `${BaseURL}/Martial/Orcs/Orc 11 E.png`;
const orc11FImage = `${BaseURL}/Martial/Orcs/Orc 11 F.png`;
const orc11GImage = `${BaseURL}/Martial/Orcs/Orc 11 G.png`;
const orc11HImage = `${BaseURL}/Special/Christmas/Orc 11 H.png`;
const orc11BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 11 B.png`;
const orc11CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 11 C.png`;
const orc11DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 11 D.png`;
const orc11EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 11 E.png`;
const orc11FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 11 F.png`;
const orc11GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 11 G.png`;
const orc11HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 11 H.png`;

const orc12AImage = `${BaseURL}/Martial/Orcs/Orc 12 A.png`;
const orc12BImage = `${BaseURL}/Martial/Orcs/Orc 12 B.png`;
const orc12CImage = `${BaseURL}/Martial/Orcs/Orc 12 C.png`;
const orc12DImage = `${BaseURL}/Martial/Orcs/Orc 12 D.png`;
const orc12EImage = `${BaseURL}/Martial/Orcs/Orc 12 E.png`;
const orc12FImage = `${BaseURL}/Martial/Orcs/Orc 12 F.png`;
const orc12GImage = `${BaseURL}/Martial/Orcs/Orc 12 G.png`;
const orc12HImage = `${BaseURL}/Special/Christmas/Orc 12 H.png`;
const orc12BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 12 B.png`;
const orc12CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 12 C.png`;
const orc12DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 12 D.png`;
const orc12EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 12 E.png`;
const orc12FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 12 F.png`;
const orc12GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 12 G.png`;
const orc12HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 12 H.png`;

const orc13AImage = `${BaseURL}/Martial/Orcs/Orc 13 A.png`;
const orc13BImage = `${BaseURL}/Martial/Orcs/Orc 13 B.png`;
const orc13CImage = `${BaseURL}/Martial/Orcs/Orc 13 C.png`;
const orc13DImage = `${BaseURL}/Martial/Orcs/Orc 13 D.png`;
const orc13EImage = `${BaseURL}/Martial/Orcs/Orc 13 E.png`;
const orc13FImage = `${BaseURL}/Martial/Orcs/Orc 13 F.png`;
const orc13GImage = `${BaseURL}/Martial/Orcs/Orc 13 G.png`;
const orc13HImage = `${BaseURL}/Special/Christmas/Orc 13 H.png`;
const orc13BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 13 B.png`;
const orc13CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 13 C.png`;
const orc13DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 13 D.png`;
const orc13EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 13 E.png`;
const orc13FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 13 F.png`;
const orc13GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 13 G.png`;
const orc13HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 13 H.png`;

const orc14AImage = `${BaseURL}/Martial/Orcs/Orc 14 A.png`;
const orc14BImage = `${BaseURL}/Martial/Orcs/Orc 14 B.png`;
const orc14CImage = `${BaseURL}/Martial/Orcs/Orc 14 C.png`;
const orc14DImage = `${BaseURL}/Martial/Orcs/Orc 14 D.png`;
const orc14EImage = `${BaseURL}/Martial/Orcs/Orc 14 E.png`;
const orc14FImage = `${BaseURL}/Martial/Orcs/Orc 14 F.png`;
const orc14GImage = `${BaseURL}/Martial/Orcs/Orc 14 G.png`;
const orc14HImage = `${BaseURL}/Special/Christmas/Orc 14 H.png`;
const orc14BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 14 B.png`;
const orc14CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 14 C.png`;
const orc14DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 14 D.png`;
const orc14EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 14 E.png`;
const orc14FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 14 F.png`;
const orc14GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 14 G.png`;
const orc14HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 14 H.png`;

const orc15AImage = `${BaseURL}/Martial/Orcs/Orc 15 A.png`;
const orc15BImage = `${BaseURL}/Martial/Orcs/Orc 15 B.png`;
const orc15CImage = `${BaseURL}/Martial/Orcs/Orc 15 C.png`;
const orc15DImage = `${BaseURL}/Martial/Orcs/Orc 15 D.png`;
const orc15EImage = `${BaseURL}/Martial/Orcs/Orc 15 E.png`;
const orc15FImage = `${BaseURL}/Martial/Orcs/Orc 15 F.png`;
const orc15GImage = `${BaseURL}/Martial/Orcs/Orc 15 G.png`;
const orc15HImage = `${BaseURL}/Special/Christmas/Orc 15 H.png`;
const orc15BPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 15 B.png`;
const orc15CPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 15 C.png`;
const orc15DPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 15 D.png`;
const orc15EPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 15 E.png`;
const orc15FPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 15 F.png`;
const orc15GPreviewImage = `${BaseURL}/Martial/Orcs/previews/Orc 15 G.png`;
const orc15HPreviewImage = `${BaseURL}/Special/Christmas/previews/Orc 15 H.png`;

export default [
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "22px",
            right: "60px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Orc",
                src: orc1AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                ],
            },
            {
                variant: "B",
                unitNumber: "1",
                filePrefix: "Orc",
                src: orc1BImage,
                previewSrc: orc1BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "cloth",
                ],
            },
            {
                variant: "C",
                unitNumber: "1",
                filePrefix: "Orc",
                src: orc1CImage,
                previewSrc: orc1CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "mace",
                    "leather",
                ],
            },
            {
                variant: "D",
                unitNumber: "1",
                filePrefix: "Orc",
                src: orc1DImage,
                previewSrc: orc1DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "armor",
                ],
            },
            {
                variant: "E",
                unitNumber: "1",
                filePrefix: "Orc",
                src: orc1EImage,
                previewSrc: orc1EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                ],
            },
            {
                variant: "F",
                unitNumber: "1",
                filePrefix: "Orc",
                src: orc1FImage,
                previewSrc: orc1FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "hammer",
                ],
            },
            {
                variant: "G",
                unitNumber: "1",
                filePrefix: "Orc",
                src: orc1GImage,
                previewSrc: orc1GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "spear",
                ],
            },
            {
                variant: "H",
                unitNumber: "1",
                filePrefix: "Orc",
                src: orc1HImage,
                previewSrc: orc1HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "mace",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "36px",
            right: "56px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                ],
            },
            {
                variant: "B",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2BImage,
                previewSrc: orc2BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "cleaver",
                    "sword",
                    "cloth",
                ],
            },
            {
                variant: "C",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2CImage,
                previewSrc: orc2CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "leather",
                ],
            },
            {
                variant: "D",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2DImage,
                previewSrc: orc2DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "axe",
                    "sword",
                    "armor",
                ],
            },
            {
                variant: "E",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2EImage,
                previewSrc: orc2EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "axe",
                    "shield",
                    "armor",
                ],
            },
            {
                variant: "F",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2FImage,
                previewSrc: orc2FPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "shield",
                ],
            },
            {
                variant: "G",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2GImage,
                previewSrc: orc2GPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "axe",
                ],
            },
            {
                variant: "H",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2HImage,
                previewSrc: orc2HPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "axe",
                    "sword",
                ],
            },
            {
                variant: "I",
                unitNumber: "2",
                filePrefix: "Orc",
                src: orc2IImage,
                previewSrc: orc2IPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "23px",
            right: "72px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "3",
                filePrefix: "Orc",
                src: orc3AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "mace",
                ],
            },
            {
                variant: "B",
                unitNumber: "3",
                filePrefix: "Orc",
                src: orc3BImage,
                previewSrc: orc3BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "cloth",
                ],
            },
            {
                variant: "C",
                unitNumber: "3",
                filePrefix: "Orc",
                src: orc3CImage,
                previewSrc: orc3CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "leather",
                ],
            },
            {
                variant: "D",
                unitNumber: "3",
                filePrefix: "Orc",
                src: orc3DImage,
                previewSrc: orc3DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "mace",
                    "armor",
                ],
            },
            {
                variant: "E",
                unitNumber: "3",
                filePrefix: "Orc",
                src: orc3EImage,
                previewSrc: orc3EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                ],
            },
            {
                variant: "F",
                unitNumber: "3",
                filePrefix: "Orc",
                src: orc3FImage,
                previewSrc: orc3FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "mace",
                ],
            },
            {
                variant: "G",
                unitNumber: "3",
                filePrefix: "Orc",
                src: orc3GImage,
                previewSrc: orc3GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "mace",
                ],
            },
            {
                variant: "H",
                unitNumber: "3",
                filePrefix: "Orc",
                src: orc3HImage,
                previewSrc: orc3HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "20px",
            right: "26px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "4",
                filePrefix: "Orc",
                src: orc4AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "eyepatch",
                ],
            },
            {
                variant: "B",
                unitNumber: "4",
                filePrefix: "Orc",
                src: orc4BImage,
                previewSrc: orc4BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "cloth",
                    "eyepatch",
                ],
            },
            {
                variant: "C",
                unitNumber: "4",
                filePrefix: "Orc",
                src: orc4CImage,
                previewSrc: orc4CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "leather",
                    "eyepatch",
                ],
            },
            {
                variant: "D",
                unitNumber: "4",
                filePrefix: "Orc",
                src: orc4DImage,
                previewSrc: orc4DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "armor",
                    "eyepatch",
                ],
            },
            {
                variant: "E",
                unitNumber: "4",
                filePrefix: "Orc",
                src: orc4EImage,
                previewSrc: orc4EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "eyepatch",
                ],
            },
            {
                variant: "F",
                unitNumber: "4",
                filePrefix: "Orc",
                src: orc4FImage,
                previewSrc: orc4FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "mace",
                    "eyepatch",
                ],
            },
            {
                variant: "G",
                unitNumber: "4",
                filePrefix: "Orc",
                src: orc4GImage,
                previewSrc: orc4GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "axe",
                    "eyepatch",
                ],
            },
            {
                variant: "H",
                unitNumber: "4",
                filePrefix: "Orc",
                src: orc4HImage,
                previewSrc: orc4HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "leather",
                    "christmas",
                    "red",
                    "eyepatch",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "20px",
            right: "57px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "5",
                filePrefix: "Orc",
                src: orc5AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "staff",
                    "magic",
                ],
            },
            {
                variant: "B",
                unitNumber: "5",
                filePrefix: "Orc",
                src: orc5BImage,
                previewSrc: orc5BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "staff",
                    "cloth",
                    "magic",
                ],
            },
            {
                variant: "C",
                unitNumber: "5",
                filePrefix: "Orc",
                src: orc5CImage,
                previewSrc: orc5CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "staff",
                    "leather",
                    "magic",
                ],
            },
            {
                variant: "D",
                unitNumber: "5",
                filePrefix: "Orc",
                src: orc5DImage,
                previewSrc: orc5DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "staff",
                    "armor",
                    "magic",
                ],
            },
            {
                variant: "E",
                unitNumber: "5",
                filePrefix: "Orc",
                src: orc5EImage,
                previewSrc: orc5EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "staff",
                    "magic",
                ],
            },
            {
                variant: "F",
                unitNumber: "5",
                filePrefix: "Orc",
                src: orc5FImage,
                previewSrc: orc5FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "staff",
                    "magic",
                ],
            },
            {
                variant: "G",
                unitNumber: "5",
                filePrefix: "Orc",
                src: orc5GImage,
                previewSrc: orc5GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "staff",
                    "magic",
                ],
            },
            {
                variant: "H",
                unitNumber: "5",
                filePrefix: "Orc",
                src: orc5HImage,
                previewSrc: orc5HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "staff",
                    "leather",
                    "christmas",
                    "red",
                    "magic",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "25px",
            right: "30px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "6",
                filePrefix: "Orc",
                src: orc6AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "shield",
                ],
            },
            {
                variant: "B",
                unitNumber: "6",
                filePrefix: "Orc",
                src: orc6BImage,
                previewSrc: orc6BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "cloth",
                    "shield",
                ],
            },
            {
                variant: "C",
                unitNumber: "6",
                filePrefix: "Orc",
                src: orc6CImage,
                previewSrc: orc6CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "leather",
                    "shield",
                ],
            },
            {
                variant: "D",
                unitNumber: "6",
                filePrefix: "Orc",
                src: orc6DImage,
                previewSrc: orc6DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "armor",
                    "shield",
                ],
            },
            {
                variant: "E",
                unitNumber: "6",
                filePrefix: "Orc",
                src: orc6EImage,
                previewSrc: orc6EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "shield",
                ],
            },
            {
                variant: "F",
                unitNumber: "6",
                filePrefix: "Orc",
                src: orc6FImage,
                previewSrc: orc6FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "mace",
                    "shield",
                ],
            },
            {
                variant: "G",
                unitNumber: "6",
                filePrefix: "Orc",
                src: orc6GImage,
                previewSrc: orc6GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "hook",
                    "shield",
                ],
            },
            {
                variant: "H",
                unitNumber: "6",
                filePrefix: "Orc",
                src: orc6HImage,
                previewSrc: orc6HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "leather",
                    "christmas",
                    "red",
                    "shield",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "34px",
            right: "53px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "7",
                filePrefix: "Orc",
                src: orc7AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "shield",
                ],
            },
            {
                variant: "B",
                unitNumber: "7",
                filePrefix: "Orc",
                src: orc7BImage,
                previewSrc: orc7BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "cloth",
                    "shield",
                ],
            },
            {
                variant: "C",
                unitNumber: "7",
                filePrefix: "Orc",
                src: orc7CImage,
                previewSrc: orc7CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "mace",
                    "leather",
                    "shield",
                ],
            },
            {
                variant: "D",
                unitNumber: "7",
                filePrefix: "Orc",
                src: orc7DImage,
                previewSrc: orc7DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "armor",
                    "shield",
                ],
            },
            {
                variant: "E",
                unitNumber: "7",
                filePrefix: "Orc",
                src: orc7EImage,
                previewSrc: orc7EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "shield",
                ],
            },
            {
                variant: "F",
                unitNumber: "7",
                filePrefix: "Orc",
                src: orc7FImage,
                previewSrc: orc7FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "sword",
                    "shield",
                ],
            },
            {
                variant: "G",
                unitNumber: "7",
                filePrefix: "Orc",
                src: orc7GImage,
                previewSrc: orc7GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "axe",
                    "shield",
                ],
            },
            {
                variant: "H",
                unitNumber: "7",
                filePrefix: "Orc",
                src: orc7HImage,
                previewSrc: orc7HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "mace",
                    "leather",
                    "christmas",
                    "red",
                    "shield",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "29px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "8",
                filePrefix: "Orc",
                src: orc8AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "ranged",
                    "woman",
                ],
            },
            {
                variant: "B",
                unitNumber: "8",
                filePrefix: "Orc",
                src: orc8BImage,
                previewSrc: orc8BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "ranged",
                    "cloth",
                    "woman",
                ],
            },
            {
                variant: "C",
                unitNumber: "8",
                filePrefix: "Orc",
                src: orc8CImage,
                previewSrc: orc8CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "ranged",
                    "leather",
                    "woman",
                ],
            },
            {
                variant: "D",
                unitNumber: "8",
                filePrefix: "Orc",
                src: orc8DImage,
                previewSrc: orc8DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "ranged",
                    "armor",
                    "woman",
                ],
            },
            {
                variant: "E",
                unitNumber: "8",
                filePrefix: "Orc",
                src: orc8EImage,
                previewSrc: orc8EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "ranged",
                    "woman",
                ],
            },
            {
                variant: "F",
                unitNumber: "8",
                filePrefix: "Orc",
                src: orc8FImage,
                previewSrc: orc8FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "bow",
                    "ranged",
                    "woman",
                ],
            },
            {
                variant: "G",
                unitNumber: "8",
                filePrefix: "Orc",
                src: orc8GImage,
                previewSrc: orc8GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "bow",
                    "ranged",
                    "woman",
                ],
            },
            {
                variant: "H",
                unitNumber: "8",
                filePrefix: "Orc",
                src: orc8HImage,
                previewSrc: orc8HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "ranged",
                    "leather",
                    "christmas",
                    "red",
                    "woman",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "19px",
            right: "42px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "9",
                filePrefix: "Orc",
                src: orc9AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hammer",
                ],
            },
            {
                variant: "B",
                unitNumber: "9",
                filePrefix: "Orc",
                src: orc9BImage,
                previewSrc: orc9BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hammer",
                    "cloth",
                ],
            },
            {
                variant: "C",
                unitNumber: "9",
                filePrefix: "Orc",
                src: orc9CImage,
                previewSrc: orc9CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hammer",
                    "leather",
                ],
            },
            {
                variant: "D",
                unitNumber: "9",
                filePrefix: "Orc",
                src: orc9DImage,
                previewSrc: orc9DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hammer",
                    "armor",
                ],
            },
            {
                variant: "E",
                unitNumber: "9",
                filePrefix: "Orc",
                src: orc9EImage,
                previewSrc: orc9EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hammer",
                ],
            },
            {
                variant: "F",
                unitNumber: "9",
                filePrefix: "Orc",
                src: orc9FImage,
                previewSrc: orc9FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "hammer",
                ],
            },
            {
                variant: "G",
                unitNumber: "9",
                filePrefix: "Orc",
                src: orc9GImage,
                previewSrc: orc9GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "hammer",
                ],
            },
            {
                variant: "H",
                unitNumber: "9",
                filePrefix: "Orc",
                src: orc9HImage,
                previewSrc: orc9HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hammer",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "18px",
            right: "44px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "10",
                filePrefix: "Orc",
                src: orc10AImage,
                tags: [
                    "orc",
                    "green",
                ],
            },
            {
                variant: "B",
                unitNumber: "10",
                filePrefix: "Orc",
                src: orc10BImage,
                previewSrc: orc10BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "cloth",
                ],
            },
            {
                variant: "C",
                unitNumber: "10",
                filePrefix: "Orc",
                src: orc10CImage,
                previewSrc: orc10CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "leather",
                ],
            },
            {
                variant: "D",
                unitNumber: "10",
                filePrefix: "Orc",
                src: orc10DImage,
                previewSrc: orc10DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "armor",
                ],
            },
            {
                variant: "E",
                unitNumber: "10",
                filePrefix: "Orc",
                src: orc10EImage,
                previewSrc: orc10EPreviewImage,
                tags: [
                    "orc",
                    "green",
                ],
            },
            {
                variant: "F",
                unitNumber: "10",
                filePrefix: "Orc",
                src: orc10FImage,
                previewSrc: orc10FPreviewImage,
                tags: [
                    "orc",
                    "red",
                ],
            },
            {
                variant: "G",
                unitNumber: "10",
                filePrefix: "Orc",
                src: orc10GImage,
                previewSrc: orc10GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                ],
            },
            {
                variant: "H",
                unitNumber: "10",
                filePrefix: "Orc",
                src: orc10HImage,
                previewSrc: orc10HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "28px",
            right: "44px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "11",
                filePrefix: "Orc",
                src: orc11AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "spear",
                    "shield",
                ],
            },
            {
                variant: "B",
                unitNumber: "11",
                filePrefix: "Orc",
                src: orc11BImage,
                previewSrc: orc11BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "spear",
                    "cloth",
                    "shield",
                ],
            },
            {
                variant: "C",
                unitNumber: "11",
                filePrefix: "Orc",
                src: orc11CImage,
                previewSrc: orc11CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "spear",
                    "leather",
                    "shield",
                ],
            },
            {
                variant: "D",
                unitNumber: "11",
                filePrefix: "Orc",
                src: orc11DImage,
                previewSrc: orc11DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "spear",
                    "armor",
                    "shield",
                ],
            },
            {
                variant: "E",
                unitNumber: "11",
                filePrefix: "Orc",
                src: orc11EImage,
                previewSrc: orc11EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "spear",
                    "shield",
                ],
            },
            {
                variant: "F",
                unitNumber: "11",
                filePrefix: "Orc",
                src: orc11FImage,
                previewSrc: orc11FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "spear",
                    "shield",
                ],
            },
            {
                variant: "G",
                unitNumber: "11",
                filePrefix: "Orc",
                src: orc11GImage,
                previewSrc: orc11GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "spear",
                    "shield",
                ],
            },
            {
                variant: "H",
                unitNumber: "11",
                filePrefix: "Orc",
                src: orc11HImage,
                previewSrc: orc11HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "spear",
                    "leather",
                    "christmas",
                    "red",
                    "shield",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "23px",
            right: "43px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "12",
                filePrefix: "Orc",
                src: orc12AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "shield",
                ],
            },
            {
                variant: "B",
                unitNumber: "12",
                filePrefix: "Orc",
                src: orc12BImage,
                previewSrc: orc12BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "mace",
                    "cloth",
                    "shield",
                ],
            },
            {
                variant: "C",
                unitNumber: "12",
                filePrefix: "Orc",
                src: orc12CImage,
                previewSrc: orc12CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "leather",
                    "shield",
                ],
            },
            {
                variant: "D",
                unitNumber: "12",
                filePrefix: "Orc",
                src: orc12DImage,
                previewSrc: orc12DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "mace",
                    "armor",
                    "shield",
                ],
            },
            {
                variant: "E",
                unitNumber: "12",
                filePrefix: "Orc",
                src: orc12EImage,
                previewSrc: orc12EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "sword",
                    "shield",
                ],
            },
            {
                variant: "F",
                unitNumber: "12",
                filePrefix: "Orc",
                src: orc12FImage,
                previewSrc: orc12FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "mace",
                    "shield",
                ],
            },
            {
                variant: "G",
                unitNumber: "12",
                filePrefix: "Orc",
                src: orc12GImage,
                previewSrc: orc12GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "sword",
                    "shield",
                ],
            },
            {
                variant: "H",
                unitNumber: "12",
                filePrefix: "Orc",
                src: orc12HImage,
                previewSrc: orc12HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "axe",
                    "leather",
                    "christmas",
                    "red",
                    "shield",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "25px",
            right: "27px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "13",
                filePrefix: "Orc",
                src: orc13AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hook",
                    "eyepatch",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
            {
                variant: "B",
                unitNumber: "13",
                filePrefix: "Orc",
                src: orc13BImage,
                previewSrc: orc13BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hook",
                    "cloth",
                    "eyepatch",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
            {
                variant: "C",
                unitNumber: "13",
                filePrefix: "Orc",
                src: orc13CImage,
                previewSrc: orc13CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hook",
                    "leather",
                    "eyepatch",
                    "animal",
                    "wolf",
                    "white",
                ],
            },
            {
                variant: "D",
                unitNumber: "13",
                filePrefix: "Orc",
                src: orc13DImage,
                previewSrc: orc13DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hook",
                    "armor",
                    "eyepatch",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
            {
                variant: "E",
                unitNumber: "13",
                filePrefix: "Orc",
                src: orc13EImage,
                previewSrc: orc13EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hook",
                    "eyepatch",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
            {
                variant: "F",
                unitNumber: "13",
                filePrefix: "Orc",
                src: orc13FImage,
                previewSrc: orc13FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "hook",
                    "eyepatch",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
            {
                variant: "G",
                unitNumber: "13",
                filePrefix: "Orc",
                src: orc13GImage,
                previewSrc: orc13GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "hook",
                    "eyepatch",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
            {
                variant: "H",
                unitNumber: "13",
                filePrefix: "Orc",
                src: orc13HImage,
                previewSrc: orc13HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "hook",
                    "leather",
                    "christmas",
                    "red",
                    "eyepatch",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "13px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "14",
                filePrefix: "Orc",
                src: orc14AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bomb",
                    "axe",
                ],
            },
            {
                variant: "B",
                unitNumber: "14",
                filePrefix: "Orc",
                src: orc14BImage,
                previewSrc: orc14BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bomb",
                    "axe",
                    "cloth",
                ],
            },
            {
                variant: "C",
                unitNumber: "14",
                filePrefix: "Orc",
                src: orc14CImage,
                previewSrc: orc14CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bomb",
                    "axe",
                    "leather",
                ],
            },
            {
                variant: "D",
                unitNumber: "14",
                filePrefix: "Orc",
                src: orc14DImage,
                previewSrc: orc14DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bomb",
                    "axe",
                    "armor",
                ],
            },
            {
                variant: "E",
                unitNumber: "14",
                filePrefix: "Orc",
                src: orc14EImage,
                previewSrc: orc14EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bomb",
                    "axe",
                ],
            },
            {
                variant: "F",
                unitNumber: "14",
                filePrefix: "Orc",
                src: orc14FImage,
                previewSrc: orc14FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "bomb",
                    "axe",
                ],
            },
            {
                variant: "G",
                unitNumber: "14",
                filePrefix: "Orc",
                src: orc14GImage,
                previewSrc: orc14GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "bomb",
                    "axe",
                ],
            },
            {
                variant: "H",
                unitNumber: "14",
                filePrefix: "Orc",
                src: orc14HImage,
                previewSrc: orc14HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bomb",
                    "axe",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "26px",
            right: "47px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "15",
                filePrefix: "Orc",
                src: orc15AImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "ranged",
                ],
            },
            {
                variant: "B",
                unitNumber: "15",
                filePrefix: "Orc",
                src: orc15BImage,
                previewSrc: orc15BPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "cloth",
                    "ranged",
                ],
            },
            {
                variant: "C",
                unitNumber: "15",
                filePrefix: "Orc",
                src: orc15CImage,
                previewSrc: orc15CPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "leather",
                    "ranged",
                ],
            },
            {
                variant: "D",
                unitNumber: "15",
                filePrefix: "Orc",
                src: orc15DImage,
                previewSrc: orc15DPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "armor",
                    "ranged",
                ],
            },
            {
                variant: "E",
                unitNumber: "15",
                filePrefix: "Orc",
                src: orc15EImage,
                previewSrc: orc15EPreviewImage,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "ranged",
                ],
            },
            {
                variant: "F",
                unitNumber: "15",
                filePrefix: "Orc",
                src: orc15FImage,
                previewSrc: orc15FPreviewImage,
                tags: [
                    "orc",
                    "red",
                    "weapon",
                    "bow",
                    "ranged",
                ],
            },
            {
                variant: "G",
                unitNumber: "15",
                filePrefix: "Orc",
                src: orc15GImage,
                previewSrc: orc15GPreviewImage,
                tags: [
                    "orc",
                    "blue",
                    "pirate",
                    "weapon",
                    "bow",
                    "ranged",
                ],
            },
            {
                variant: "H",
                unitNumber: "15",
                filePrefix: "Orc",
                src: orc15HImage,
                previewSrc: orc15HPreviewImage,
                legendary: true,
                tags: [
                    "orc",
                    "green",
                    "weapon",
                    "bow",
                    "leather",
                    "christmas",
                    "red",
                    "ranged",
                ],
            },
        ]
    },
];
